import { FC } from "react";
import { IllustrationWrapper } from "../IllustrationWrapper";
import { IllustrationProps } from "../Illustrations.types";

const OrangeBonusActivitySubscribers: FC<IllustrationProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName="OrangeBonusActivitySubscribers"
      illustration={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={restProps?.width ?? "24"}
          height={restProps?.height ?? "24"}
          viewBox="0 0 48 48"
          fill="none"
          {...props}
        >
          <path
            d="M47.3929 18.1014C48.7024 20.3695 48.7024 23.164 47.3929 25.4321L39.0583 39.8681C37.7487 42.1362 35.3287 43.5335 32.7096 43.5335H16.0404C13.4214 43.5335 11.0013 42.1362 9.69175 39.8681L1.35714 25.4321C0.0476209 23.164 0.0476209 20.3695 1.35714 18.1014L9.69175 3.66539C11.0013 1.39724 13.4214 0 16.0404 0H32.7096C35.3287 0 37.7487 1.39724 39.0582 3.66539L47.3929 18.1014Z"
            fill="#EF9D7B"
          />
          <path
            d="M43.1128 18.3027C44.1788 20.1491 44.1788 22.424 43.1128 24.2704L36.3279 36.0221C35.2619 37.8685 33.2918 39.006 31.1597 39.006H17.59C15.4579 39.006 13.4878 37.8685 12.4218 36.0221L5.63692 24.2704C4.5709 22.424 4.5709 20.1491 5.63692 18.3027L12.4218 6.55092C13.4878 4.70451 15.4579 3.56708 17.59 3.56708H31.1597C33.2918 3.56708 35.2619 4.70451 36.3279 6.55092L43.1128 18.3027Z"
            fill="black"
          />
          <path
            d="M43.1127 20.1927C44.1787 21.969 44.1787 24.1573 43.1127 25.9335L36.3278 37.2385C35.2618 39.0147 33.2917 40.1089 31.1597 40.1089H17.5899C15.4579 40.1089 13.4878 39.0147 12.4218 37.2385L5.63692 25.9335C4.5709 24.1573 4.5709 21.969 5.63692 20.1927L12.4218 8.88779C13.4878 7.11159 15.4579 6.0174 17.5899 6.0174H31.1597C33.2917 6.0174 35.2618 7.11158 36.3278 8.88779L43.1127 20.1927Z"
            fill="#EF9D7B"
          />
          <path
            d="M15.0146 8.01746C15.0146 6.91289 15.9101 6.01746 17.0146 6.01746H31.6763C32.7808 6.01746 33.6763 6.91289 33.6763 8.01746V30.5865C33.6763 31.3789 32.7986 31.8565 32.1332 31.4261L24.8876 26.7398C24.5571 26.526 24.1319 26.526 23.8014 26.7399L16.5578 31.4259C15.8925 31.8563 15.0146 31.3787 15.0146 30.5863V8.01746Z"
            fill="white"
          />
          <path
            d="M24.3457 8.46124V19.9122"
            stroke="#EF9D7B"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M17.501 6.01746V26.6411C17.501 27.0311 17.9275 27.2709 18.2607 27.0684L24.1528 23.4861C24.3131 23.3886 24.5146 23.3891 24.6744 23.4874L30.4866 27.0617C30.8198 27.2666 31.2485 27.0269 31.2485 26.6358V6.01746"
            stroke="#EF9D7B"
            strokeWidth="1.5"
          />
          <path
            d="M28.4076 34.278C28.4076 34.278 28.1331 34.1864 27.7518 34.0595C26.4365 33.621 25.3894 32.574 24.951 31.2588C24.824 30.8774 24.7324 30.6029 24.7324 30.6029C24.6769 30.4363 24.521 30.324 24.3454 30.324C24.1698 30.324 24.014 30.4363 23.9584 30.6029C23.9584 30.6029 23.8668 30.8774 23.7399 31.2587C23.3014 32.574 22.2544 33.621 20.9392 34.0594C20.5578 34.1864 20.2833 34.278 20.2833 34.278C20.1167 34.3336 20.0044 34.4895 20.0044 34.6651C20.0044 34.8406 20.1168 34.9965 20.2833 35.0521C20.2833 35.0521 20.5578 35.1436 20.9391 35.2706C22.2544 35.709 23.3014 36.756 23.7398 38.0713C23.8668 38.4526 23.9584 38.7272 23.9584 38.7272C24.014 38.8937 24.1698 39.0061 24.3454 39.0061C24.521 39.0061 24.6769 38.8937 24.7325 38.7272C24.7325 38.7272 24.8241 38.4527 24.951 38.0714C25.3895 36.7561 26.4365 35.709 27.7517 35.2706C28.1331 35.1436 28.4076 35.0521 28.4076 35.0521C28.5742 34.9965 28.6865 34.8407 28.6865 34.6651C28.6865 34.4895 28.5742 34.3336 28.4076 34.278Z"
            fill="white"
          />
        </svg>
      }
      {...restProps}
    />
  );
};

export default OrangeBonusActivitySubscribers;
